import React from 'react'
import CheckIcon from '@mui/icons-material/Check'
import { SvgIconProps } from '@mui/material';

interface Props {
    visible?: boolean
}

const CheckMark: React.FC<Props & SvgIconProps> = props => {
    const {visible, ...rest} = props
    if (!visible) {
        return null
    }
    return <CheckIcon fontSize={'small'} {...rest} />
}
CheckMark.displayName = 'CheckMark'
export default CheckMark
